var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3327 8.5465L23.4527 6.6665L15.9993 14.1198L8.54602 6.6665L6.66602 8.5465L14.1193 15.9998L6.66602 23.4532L8.54602 25.3332L15.9993 17.8798L23.4527 25.3332L25.3327 23.4532L17.8793 15.9998L25.3327 8.5465Z",
    fill: "#8C9EBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconLight);
export default __webpack_public_path__ + "static/media/close_icon_light.b44840d00c945764298b3d370ef5b809.svg";
export { ForwardRef as ReactComponent };